import React from 'react';
import Header from './Header';
import FaucetForm from './FaucetForm';

const App = () => {
    return (
        <>
            <Header></Header>
            <FaucetForm></FaucetForm>
        </>
    );
}

export default App;
